import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdDoubleArrow } from "react-icons/md";
import { WiTime2 } from "react-icons/wi";
import { useDispatch, useSelector } from "react-redux";
import { listSurveys } from "../redux/slice/feedbackSlice";
import DashboardHeader from "./components/DashboardHeader";
import DashboardTabbar from "./components/DashboardTabbar";

const FeedbackPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const surveys = useSelector((state) => state.feedbackSurvey);

  const surveysData = surveys?.surveys?.data || [];

  useEffect(() => {
    dispatch(listSurveys());
  }, [dispatch]);

  const openSurvey = (surveyId) => {
    navigate(`/feedback-survey/${surveyId}`);
  };

  return (
    <div>
      <DashboardHeader />
      <div className="container mt-4 min-h">
        <DashboardTabbar />
        <div className="site-card-wrapper">
          <h2 className="h3 mb-4">Feedback Surveys Assigned</h2>
          <div className="cards-container row row-cols-2 row-cols-sm-2 row-cols-md-4 row-cols-lg-3">
            {surveysData.map((item, index) => (
              <div className="col mb-4" key={index}>
                <div
                  className="survey-card feedback-survey-card"
                  onClick={() => openSurvey(item._id)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="feedback-data">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="loi">
                        <WiTime2 /> {item.loi} min
                      </span>
                      <span className="loi">Status: {item.status}</span>
                    </div>
                    <p>Earn - ₹{item.reward?.amount}</p>
                    <p>Expire Date - {item.endDate?.split("T")[0]}</p>
                    <span className="start-btn">
                      <MdDoubleArrow />
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPage;
